"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/faqSection.tsx */

import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FaqSectionAccordionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    className: string;
    /** Detected variants: "We encourage regular sessions to track progress and provide ongoing support. Frequency depends on individual needs." | "Yes, we offer customized treatments specially designed for sensitive skin using gentle, dermatologist-approved products and techniques." | "Results vary depending on the treatment and skin condition. Some treatments show immediate results, while others may require multiple sessions." | "Yes, we recommend a consultation to understand your skin concerns and create a personalized treatment plan." */
    p0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" */
    id: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" | "headingFour" */
    h30Id: string;
    /** Detected variants: "Is virtual therapy right for me?" | "Do you work with adults, adolescents, or children?" | "Are your therapists licensed to practice?" */
    link0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    link0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" | "#collapseFour" */
    dataBsTarget: string;
    /** Detected variants: "accordion-item" */
    divClassName?: string;
    /** Detected variants: "#faq-details-one" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName2?: string;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeFifteenFaqSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    divH30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Commonly Asked" */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Questions" */
    sectionDiv0Div0Div1Div0H20Span0SpanText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div1DivDataWowDuration?: string;
    /** Default: "faq-details-one" */
    sectionDiv0Div0Div1Div1Div0DivId?: string;
    faqSectionAccordions: FaqSectionAccordionsItem[];
    faqSectionAccordionsItemWrapper?: (item: FaqSectionAccordionsItem, content: ReactNode) => ReactNode;
    faqSectionAccordionsRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkVisible?: boolean;
    faqSectionAccordionsLinkRenderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsH3Visible?: boolean;
    faqSectionAccordionsH3Renderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    faqSectionAccordionsH3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFifteenFaqSectionGenerated: FC<HomeFifteenFaqSectionGeneratedProps> = ({
    sectionDiv0Div0Div1Div0H20H2Text = "Commonly Asked",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    sectionDiv0Div0Div1Div0H20Span0SpanText = "Questions",
    sectionDiv0Div0Div1Div1Div0DivId = "faq-details-one",
    sectionDiv0Div0Div1Div1DivDataWowDuration = "1s",
    divH30H3Props,
    divH30Link0LinkProps,
    sectionDiv0Div0ClassName,
    faqSectionAccordions,
    faqSectionAccordionsItemWrapper,
    faqSectionAccordionsRenderer,
    faqSectionAccordionsLinkVisible,
    faqSectionAccordionsLinkRenderer,
    faqSectionAccordionsH3Visible,
    faqSectionAccordionsH3Renderer,
    faqSectionAccordionsLinkProps,
    faqSectionAccordionsH3Props,
}) => {
    return (
        <section className="section faq-section-fifteen">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-xl-6 col-lg-5" />
                    <div className="col-xl-6 col-lg-7">
                        <div className="section-header section-header-fifteen">
                            {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div1Div0H20H2Text}
                                    <span>{sectionDiv0Div0Div1Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                        <div className="faq-info faq-info-fifteen wow zoomIn" data-wow-duration={sectionDiv0Div0Div1Div1DivDataWowDuration}>
                            <div className="accordion" id={sectionDiv0Div0Div1Div1Div0DivId}>
                                {renderCollectionNode(
                                    faqSectionAccordions,
                                    (item: FaqSectionAccordionsItem) => (
                                        <div className={item.divClassName ?? "accordion-item"} key={item.key}>
                                            {renderItemNode(faqSectionAccordionsH3Visible, faqSectionAccordionsH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof faqSectionAccordionsH3Props === "function" ? faqSectionAccordionsH3Props(item) : (faqSectionAccordionsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                    {renderItemNode(faqSectionAccordionsLinkVisible, faqSectionAccordionsLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls} {...(typeof faqSectionAccordionsLinkProps === "function" ? faqSectionAccordionsLinkProps(item) : (faqSectionAccordionsLinkProps ?? {}))} {...(typeof divH30Link0LinkProps === "function" ? divH30Link0LinkProps(item) : (divH30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                            <div id={item.id} className={item.className} data-bs-parent={item.dataBsParent ?? "#faq-details-one"}>
                                                <div className={item.div0ClassName ?? "accordion-body"}>
                                                    <div className={item.div0ClassName2 ?? "accordion-content"}>
                                                        <p>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    faqSectionAccordionsItemWrapper,
                                    faqSectionAccordionsRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFifteenFaqSectionGenerated;
